import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["menu", "chevron"];

  connect() {
    // Add click event listener to document to close dropdown when clicking outside
    document.addEventListener("click", this.closeOnClickOutside.bind(this));
  }

  disconnect() {
    // Remove event listener when controller is disconnected
    document.removeEventListener("click", this.closeOnClickOutside.bind(this));
  }

  async toggle(event) {
    event.stopPropagation();
    const open = !this.menuTarget.classList.toggle("hidden");
    this.chevronTarget.classList.toggle("rotate-180");
    if (open) {
      console.log("open");
      await get("/account/credits", {
        responseKind: "turbo-stream",
      });
    }
  }

  // Method to handle clicks outside the dropdown
  closeOnClickOutside(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }

  // Method to prevent clicks inside the dropdown from closing it
  stopPropagation(event) {
    event.stopPropagation();
  }
}
